import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Aviso bloqueante (no descartable con click afuera) que se muestra cuando el
// backend responde 401 en una request autenticada. A propósito no navega solo:
// espera a que el usuario confirme, para no destruir formularios en curso.
export default function SessionExpiredNotice() {
  const { sesionExpirada, logout } = useAuth();
  const navigate = useNavigate();

  if (!sesionExpirada) return null;

  const irALogin = () => {
    logout();
    navigate('/login');
  };

  return (
    <div style={styles.overlay} role="alertdialog" aria-modal="true" aria-label="Sesión expirada">
      <div style={styles.modal}>
        <p style={styles.titulo}>Tu sesión ha expirado</p>
        <p style={styles.texto}>
          Por seguridad cerramos tu sesión. Lo que tenías escrito en esta pantalla sigue aquí;
          inicia sesión de nuevo para continuar.
        </p>
        <button onClick={irALogin} style={styles.boton}>Ir a iniciar sesión</button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(8,9,13,.72)', zIndex: 3000,
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px',
  },
  modal: {
    width: '100%', maxWidth: '380px', background: 'var(--modal-bg, #171B24)',
    border: '1px solid var(--modal-border, #313B4C)', borderRadius: '14px', padding: '24px',
    textAlign: 'center', color: 'var(--text, #F3F4F6)', boxShadow: '0 30px 80px rgba(0,0,0,.5)',
  },
  titulo: { fontSize: '16px', fontWeight: '800', margin: '0 0 8px' },
  texto: { fontSize: '13px', color: 'var(--gray, #9CA3AF)', lineHeight: '1.5', margin: '0 0 18px' },
  boton: {
    border: 'none', borderRadius: '9px', padding: '11px 18px', background: '#FF2D78', color: '#fff',
    fontSize: '13.5px', fontWeight: '700', cursor: 'pointer', width: '100%',
  },
};
